const MentionsLegales = () => (
  <div className="max-w-4xl mx-auto space-y-6 px-6 py-12 prose prose-lg">
    <div className="bg-[#003f97] text-white p-16">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl font-bold">
          Mentions Légales et Politique de Confidentialité – Intranet CEISNA
        </h1>
      </div>
    </div>

    <section className=" flex flex-col space-y-2">
      <h2>1. Présentation du traitement et cadre réglementaire</h2>
      <p>
        Le Comité d’Experts Internationaux en Santé Numérique pour l’Afrique
        (CEISNA) est un organisme dédié à la promotion de la santé numérique en
        Afrique, réunissant des experts de divers horizons. Afin de faciliter la
        collaboration, la gestion administrative et scientifique, CEISNA met à
        disposition un site intranet sécurisé, exclusivement réservé à ses
        membres experts. Ce portail permet la gestion des profils
        professionnels, l’accès à des documents de travail, la diffusion de
        formations et webinaires, ainsi que la communication interne.
      </p>
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD,
        Règlement (UE) 2016/679), notamment ses articles 5 (principes relatifs
        au traitement), 6 (licéité du traitement), 12 et 14 (information des
        personnes concernées), ainsi qu’à la directive ePrivacy (Directive
        2002/58/CE modifiée), CEISNA s’engage à garantir la protection des
        données à caractère personnel traitées au sein de cet intranet. Les
        dispositions légales nationales applicables en Afrique, le cas échéant,
        sont également respectées, dans un souci d’harmonisation et de
        conformité aux standards internationaux.
      </p>
    </section>

    <section>
      <h2>2. Finalités précises du traitement des données personnelles</h2>
      <ul>
        <li>
          Assurer l’identification claire et fiable de chaque expert, notamment
          pour la reconnaissance de leur expertise, la coordination des
          activités et la gestion administrative.
        </li>
        <li>
          Faciliter l’organisation et le suivi des commissions, groupes de
          travail, missions et projets dans lesquels les experts sont impliqués.
        </li>
        <li>
          Permettre la diffusion ciblée et sécurisée de documents
          professionnels, rapports, publications, webinaires et contenus
          pédagogiques pour renforcer les compétences et la mise à jour
          scientifique des membres.
        </li>
        <li>
          Assurer la gestion des accès et droits des utilisateurs sur la
          plateforme intranet, notamment via un système d’authentification
          robuste.
        </li>
        <li>
          Répondre aux obligations légales, réglementaires ou contractuelles,
          notamment en matière d’audit, de traçabilité et de certification des
          experts.
        </li>
        <li>
          Améliorer la qualité des services internes grâce à une analyse anonyme
          des usages, dans le respect des règles de confidentialité.
        </li>
      </ul>
    </section>

    <section>
      <h2>3. Base légale et licéité du traitement</h2>
      <ul>
        <li>
          <strong>Consentement explicite :</strong> Les experts donnent leur
          consentement clair, libre, éclairé et univoque avant l’inscription
          (art. 7 RGPD).
        </li>
        <li>
          <strong>Exécution d’un contrat :</strong> Le traitement est nécessaire
          à la bonne exécution des conventions liant les experts au CEISNA.
        </li>
        <li>
          <strong>Respect d’obligations légales :</strong> Conservation ou
          traitement requis pour satisfaire à des obligations réglementaires.
        </li>
        <li>
          <strong>Intérêt légitime :</strong> Sécurité du système, prévention
          des fraudes, gestion de la relation entre experts.
        </li>
      </ul>
    </section>

    <section>
      <h2>4. Nature et catégories des données collectées</h2>
      <ul>
        <li>
          <strong>Informations d’identification :</strong> nom, prénom, adresse
          email professionnelle, identifiant interne.
        </li>
        <li>
          <strong>Données professionnelles :</strong> titre, spécialité,
          institution, pays de résidence.
        </li>
        <li>
          <strong>Profil d’activité :</strong> compétences, missions, historique
          de formations et certifications.
        </li>
        <li>
          <strong>Contenus biographiques :</strong> parcours, publications,
          contributions scientifiques.
        </li>
        <li>
          <strong>Interactions :</strong> historique de connexion, documents
          consultés, participation aux webinaires.
        </li>
      </ul>
      <p>
        <em>
          Les données sensibles (informations médicales) ne sont collectées que
          dans des cas strictement encadrés et avec consentement explicite.
        </em>
      </p>
    </section>

    <section>
      <h2>5. Confidentialité, accès restreint et gouvernance</h2>
      <ul>
        <li>
          Seuls les administrateurs du système, les responsables de commissions
          et les experts concernés ont accès aux données nécessaires à leurs
          fonctions.
        </li>
        <li>
          Tout accès est soumis à un engagement de confidentialité et à des
          formations régulières.
        </li>
        <li>
          Des audits périodiques vérifient la conformité des accès et la
          traçabilité des opérations.
        </li>
      </ul>
    </section>

    <section>
      <h2>6. Sécurité renforcée des données</h2>
      <ul>
        <li>Authentification multi-facteurs (MFA).</li>
        <li>Chiffrement des données au repos et en transit (TLS/SSL).</li>
        <li>Pare-feu, IDS et protection DDoS.</li>
        <li>Sauvegardes régulières et plan de reprise après sinistre.</li>
        <li>Mises à jour et correctifs de sécurité continus.</li>
        <li>Formation et sensibilisation du personnel.</li>
      </ul>
    </section>

    <section>
      <h2>7. Utilisation de cookies et technologies similaires</h2>
      <p>
        Des cookies strictement nécessaires gèrent la session, personnalisent
        les préférences et sécurisent les accès. Ils ne servent pas à du suivi
        publicitaire. L’utilisateur est informé dès sa première connexion et
        peut configurer ou désactiver les cookies via son navigateur.
      </p>
    </section>

    <section>
      <h2>8. Durée de conservation des données</h2>
      <ul>
        <li>
          Données d’expert conservées pendant toute la durée de son engagement.
        </li>
        <li>Archivage post-collaboration pour audit (généralement 5 ans).</li>
        <li>Suppression ou anonymisation irréversible au terme défini.</li>
      </ul>
    </section>

    <section>
      <h2>9. Droits des experts utilisateurs</h2>
      <ul>
        <li>Droit d’accès</li>
        <li>Droit de rectification</li>
        <li>Droit à l’effacement</li>
        <li>Droit à la limitation du traitement</li>
        <li>Droit à la portabilité</li>
        <li>Droit d’opposition</li>
      </ul>
      <p>
        Pour exercer ces droits, contactez notre DPO :{" "}
        <a href="mailto:contact@ceisna.org">contact@ceisna.org</a>. Réponse sous
        un mois.
      </p>
    </section>

    <section>
      <h2>10. Contact et réclamations</h2>
      <p>
        <strong>DPO CEISNA</strong>
        Email : <a href="mailto:contact@ceisna.org">contact@ceisna.org</a>
        Adresse : 61 Rue de Lyon, 75012 Paris
      </p>
      <p>
        En cas de litige, vous pouvez saisir l’autorité de contrôle compétente
        selon le RGPD.
      </p>
    </section>

    <section>
      <h2>11. Évolutions et mise à jour de la politique</h2>
      <p>
        Cette politique peut évoluer pour rester conforme aux évolutions
        législatives et techniques. Toute modification significative sera
        notifiée via l’intranet.
      </p>
    </section>
  </div>
);

export default MentionsLegales;
